'use client'
import { useSearchParams } from "next/navigation";
import {useCookie} from "./AppHooks";

const AppReferral = () => {
	const searchParams = useSearchParams();
    const referralCode  = searchParams.get("referral") || null;
    const [referral, setReferral] = useCookie("referral");
    if(referralCode) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 10); // Expires in 10 days
        setReferral(referralCode, expirationDate);
        console.log(referral);
    }

    return null;
}

export default AppReferral;
